export default "__VITE_ASSET__0d7b27a4__"